import { DayInfo } from '../../../services/companyTimesheetUserService'

export function getUniqueWeekNumbers(dayInfos: DayInfo[]): number[] {
    const uniqueWeekNumbers = new Set<number>()
    dayInfos.forEach((dayInfo) => uniqueWeekNumbers.add(dayInfo.weekNumber))
    return Array.from(uniqueWeekNumbers)
}
